export default "__VITE_ASSET__CyERaArR__"